import styled from "styled-components";
import { styledByTheme } from "../../../themes/architecture/styled-by-theme";

const WelcomeGreetingDefaultBox = styled.p`
    margin: 0.5rem 0;
    font-family: ${({theme}) => theme.font.family.regular};
    font-weight: 300;
    font-size: 1.4rem;
    line-height: 1;
    color: ${({theme}) => theme.colors.bodyText};
`;

const WelcomeGreetingCasino777Box = styled(WelcomeGreetingDefaultBox)`
    font-family: ${({theme}) => theme.font.family.bold};
    font-weight: 700;
    font-size: 1.6rem;
`;

export const WelcomeGreetingBox = styledByTheme(WelcomeGreetingDefaultBox).forCasino777(WelcomeGreetingCasino777Box).apply();
